import React, { type SyntheticEvent } from 'react';
import type { InputProps } from '@atlaskit/select';
import { SearchField } from '@atlassian/jira-searchfield/src/index.tsx';
import type { ItemGroup } from '../../../model/index.tsx';

type Props = {
	placeholder: string;
	onChange: (arg1: string) => void;
	value: string;
	inputProps: InputProps<ItemGroup>;
};

const Input = ({ placeholder, onChange, value, inputProps: selectInputProps }: Props) => {
	const inputProps = {
		'aria-activedescendant': selectInputProps['aria-activedescendant'],
		'aria-autocomplete': selectInputProps['aria-autocomplete'],
		'aria-controls': selectInputProps['aria-controls'],
		'aria-errormessage': selectInputProps['aria-errormessage'],
		'aria-expanded': selectInputProps['aria-expanded'],
		'aria-haspopup': selectInputProps['aria-haspopup'],
		'aria-invalid': selectInputProps['aria-invalid'],
		role: selectInputProps.role,
	};

	return (
		<SearchField
			isAlwaysExpanded
			placeholder={placeholder}
			autoFocus
			shouldFitContainerWidth
			onChange={onChange}
			value={value}
			id={selectInputProps.id}
			describedById={selectInputProps['aria-describedby']}
			ariaLabelText={selectInputProps['aria-label']}
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			onFocus={selectInputProps.onFocus as (arg1: SyntheticEvent<HTMLElement, Event>) => void}
			inputProps={inputProps}
		/>
	);
};

export default Input;
